<div class="cart-summary-box">
  <div class="d-flex flex-stack fw-bold">
    <p class="mb-0 fs-4 fw-semibold">{{ "APP.TOTAL_PRICE" | translate }}:</p>
    <p class="mb-0 fs-2 fw-bold">
      {{ userCart()?.total_price | currency : "฿" }}
    </p>
  </div>
  <div class="d-flex flex-stack my-3 mb-4">
    <div class="mb-0 fs-5 fw-semibold">
      {{ "APP.COURSE_DISCOUNT" | translate }}
    </div>
    <!-- Red is the alarm colour and a discount of zero is not an alarm:
         "-฿0.00" in danger red read as something wrong with the cart. -->
    <div class="mb-0 fs-4 fw-bold" [class.text-danger]="(userCart()?.total_discount || 0) > 0">
      @if ((userCart()?.total_discount || 0) > 0) {
      -{{ userCart()?.total_discount | currency : "฿" }}
      } @else {
      <span class="text-muted fw-semibold">—</span>
      }
    </div>
  </div>

  <!-- TODO next phase -->
  <div class="d-flex flex-stack pt-3 pb-2 mt-2 border-top">
    <div class="mb-0 fs-5 fw-semibold">
      {{ "APP.DISCOUNT_CODE" | translate }}:
    </div>
  </div>
  @if(discountCode()){
  <div class="d-flex flex-stack pb-8 gap-4 align-items-start">
    <div class="mb-0 fs-5 fw-semibold">{{ discountCode().name }}</div>
    <div class="mb-0 fs-4 fw-bold text-nowrap">
      <div>
        -{{
          discountCode().total_discount_after_discount_code | currency : "฿"
        }}
      </div>
      <div
        class="cursor-pointer text-end text-danger fs-6 fw-normal text-hover-underline"
        (click)="removeDiscount()"
      >
        {{ "COMPONENT.DELETE" | translate }}
      </div>
    </div>
  </div>
  }
  <button
    type="button"
    class="btn btn-outline-light text-left form-control border h-50px px-4"
    (click)="openDiscountCode()"
  >
    <div class="d-flex flex-row align-items-center gap-2">
      <app-keenicon name="price-tag" class="fs-1"></app-keenicon>
      <span class="text-dark">{{ "APP.DISCOUNT" | translate }}</span>
    </div>
  </button>

  <div class="d-flex flex-stack py-8 border-top mt-4">
    <div class="mb-0 fs-1 fw-semibold">{{ "TABLE.SUB_TOTAL" | translate }}</div>
    <div
      class="mb-0 fs-2x fw-bold"
      [ngClass]="{ 'text-danger': discountCode() }"
    >
      @if(!discountCode()){
      {{ userCart()?.total_net_price | currency : "฿" }}

      }@else{

      {{ discountCode()?.total_net_price_after_discount_code | currency : "฿" }}
      }
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <button
        class="btn btn-light-danger text-danger text-hover-white col-12"
        [disabled]="!userCart()?.course_list.length"
        (click)="cancel()"
      >
        {{ "APP.CANCEL_ORDER" | translate }}
      </button>
    </div>
    <div class="col-6">
      <button
        class="btn btn-primary col-12"
        data-testid="pay"
        [disabled]="!userCart()?.course_list.length"
        (click)="pay()"
      >
        {{ "APP.PAY" | translate }}
      </button>
    </div>
    <!----><!---->
  </div>
</div>
